import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useValuatorReducer = () => useSelector((state: ApplicationState) => state.valuator);
